const STYLE_ANIMATE_IN = '-animating-in';
const STYLE_ANIMATED_IN = '-animated-in';

export default class WebsiteElement {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        /**
         * @type {HTMLElement}
         * @private
         */
        this._element = element;

        /**
         * @type {boolean}
         * @private
         */
        this._animatedIn = false;

        /**
         * @type {number}
         * @private
         */
        this._animateInTiming = 1000;
    }

    /**
     * Kijkt of het element boven de onderkant van de viewport zit.
     *
     * @param {number} bottom
     *
     * @returns {boolean}
     */
    isAbove(bottom) {
        return ((this._element.offsetTop + 200) <= bottom);
    }

    isAnimatedIn() {
        this._animatedIn = true;

        this._element.classList.add(STYLE_ANIMATED_IN);
        this._element.classList.remove(STYLE_ANIMATE_IN);
    }

    notAnimatedIn() {
        this._animatedIn = false;

        this._element.classList.remove(STYLE_ANIMATED_IN);
    }

    /**
     *
     * @returns {void}
     */
    animateIn() {
        this._element.classList.add(STYLE_ANIMATE_IN);

        setTimeout(() => {
            this.isAnimatedIn();
        }, this.animateInTiming);
    }

    /**
     * @returns {boolean}
     */
    isVisible() {
        return this._animatedIn;
    }

    /**
     * @param {number} time
     */
    set animateInTiming(time) {
        this._animateInTiming = time;
    }

    /**
     * @returns {number}
     */
    get animateInTiming() {
        return this._animateInTiming;
    }
}